import React from "react"
import BusinessBootcampSoloVideo from "./BusinessBootcampSoloVideo"

const CEOVideo = () => {
  return (
    <section className="bg-blurple py-[72px] md:py-[96px] px-6 md:px-12 mt-16">
      <div
        className="max-w-screen-xl mx-auto flex flex-col lg:flex-row items-center gap-10 bg-white rounded-2xl p-8 md:px-16 md:py-12 shadow-lg"
        style={{ fontFamily: "BeausiteClassic" }}
      >
        {/* Left Section - Text */}
        <div className="lg:w-1/2 flex justify-start lg:pr-8">
          <p
            className="text-black font-normal"
            style={{
              fontSize: "22px",
              lineHeight: "30px",
            }}
          >
            Hear directly from Nichole Lowe, Founder & CEO of Zoee, on why this
            bootcamp was created, and why helping coaches build sustainable
            businesses is at the heart of Zoee’s mission.
          </p>
        </div>

        {/* Right Section - Video */}
        <div className="lg:w-1/2 flex justify-center lg:justify-end lg:pl-8 w-full">
          <div className="relative w-full max-w-[600px] aspect-video overflow-hidden shadow-lg">
            <BusinessBootcampSoloVideo />
          </div>
        </div>
      </div>
    </section>
  )
}

export default CEOVideo
